module.exports = __webpack_public_path__ + "img/working-2-1024x768.8c684754.jpg";